import {defaultImage} from "./assets/defaultImage";

export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN;

export const DEFAULT_LANDING_PAGE_ORDER = ["about_us", "services", "why_us", "batches", "events", "gallery", "testimonials", "appointment_enquiry_cards"];

export const PAGE_TYPE = {
  YOGA_WAV_HOME: "YOGA_WAV_HOME",
  ALPHA_LANDING: "ALPHA_LANDING",
  NOT_FOUND: "NOT_FOUND",
  AUTH: "AUTH",
};

export const IMAGE_FOLDERS_NAME = {
    PC: "/pc/",
    THUMB: "/thumb/",
    MOBILE: "/mobile/"
}

export const BASE_URL = `https://api.${BASE_DOMAIN}`;
export const ALPHA_URL = BASE_DOMAIN?.trim()
  ? `https://app.${BASE_DOMAIN.trim()}`
  : "https://app.yogappify.com";
export const WHATSAPP_NUMBER = "919245412459";

export const PAYMENT_MODES = {
    ONLINE: "Online",
    PAYMENT_LINK: "Payment Link",
    CASH: "Cash",
    CHEQUE: "Cheque",
    DRAFT: "Draft",
};

const toBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};

export const setBackgroundImageWithFallback = async (element, imageUrl, isMobile) => {
    try {
        const finalUrl = `${isMobile ? imageUrl.replace(IMAGE_FOLDERS_NAME.PC, IMAGE_FOLDERS_NAME.MOBILE) : imageUrl}?v=${Date.now()}`;

        const base64 = await toBase64(finalUrl);
        element.style.backgroundImage = `url(${base64})`;
    } catch {
        element.style.backgroundImage = `url(${defaultImage})`;
    }
};

export const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = defaultImage;
};
